import React, { useMemo } from 'react';
import { Card, Image, Tooltip } from 'antd';
import DefaultImage from './default-image.png';
import truncateText from '../../../../../../../utils/truncateText';
import InitialsAvatar from '../../../../../../CustomizedAntDesign/InitialsAvatar';
import formatToCurrency from '../../../../../../../utils/formatToCurrency';
import { isImageFile, getFileExtension, FILE_RECT_ICONS } from '../../../../../../../utils/fileTypeIcons';
import './styles.css';

const CollectionProductCard = props => {
  const { product, onClick } = props;

  const isAttachment = product.type === 'attachment';
  const isImage = isImageFile(product.fileType);
  const fileExtension = getFileExtension(product.fileName);
  const fileIcon = FILE_RECT_ICONS[fileExtension];

  const productName = useMemo(
    () => product.name ?? product.description ?? product.fileName ?? '',
    [product.description, product.fileName, product.name]
  );

  const price = useMemo(() => {
    const value = product.vendorId ? product.msrp : product.price;

    return formatToCurrency(`${value}`);
  }, [product.price, product.vendorId, product.msrp]);

  return (
    <Card className="clients-v2-collection-product--card" onClick={onClick} hoverable>
      <div className={`clients-v2-collection-product--card-header${isAttachment && !isImage && fileIcon ? ' file-icon-header' : ''}`}>
        <Image
          src={isAttachment && !isImage && fileIcon ? fileIcon : (product.images?.[0]?.sourceUrl || product.url)}
          width={220}
          height={220}
          preview={false}
          fallback={isAttachment && fileIcon ? fileIcon : DefaultImage}
          style={isAttachment && !isImage && fileIcon ? { objectFit: 'contain', backgroundColor: '#f5f5f5' } : undefined}
        />

        {!isAttachment && <div className="clients-v2-collection-product--card-header-price">{price}</div>}
      </div>

      <div className="clients-v2-collection-product--card-body">
        <span className="clients-v2-collection-product--card-body-title">
          <Tooltip title={productName}>{truncateText(productName, 24, { cutWords: true })}</Tooltip>
        </span>

        {!isAttachment && <span className="clients-v2-collection-product--card-body-subtitle">{product.id}</span>}
      </div>

      <div className="clients-v2-collection-product--card-footer">
        <InitialsAvatar size={25} name={product.added_by_name} style={{ backgroundColor: '#F2A39B' }} />

        <span className="clients-v2-collection-product--card-footer-title">
          <Tooltip title={`Added by  ${product.added_by_name}`}>
            {truncateText(`Added by  ${product.added_by_name}`, 18, { cutWords: true })}
          </Tooltip>
        </span>
      </div>
    </Card>
  );
};

export default CollectionProductCard;
